export default __webpack_public_path__ + "static/media/Service2.7f402e90.jpg";